import React, { useState } from "react";
import "./updateParent.scss";

import { Close, Person2Sharp } from "@mui/icons-material";

import "react-phone-input-2/lib/style.css";
// import ReactFlagsSelect from "react-flags-select";
import { IconButton } from "@mui/material";
import {
  domaineType,
  fonctionType,
  gradeType,
  ParentType,
  requestType,
} from "../../../types/GlobalType.ts";
import toast, { LoaderIcon } from "react-hot-toast";
import { accountService } from "../../../_services/accountServices.js";
import { catchErrorApiCall } from "../../../_services/apiUtils.js";
import ErrorBar from "../../../component/errorComp/ErrorBar.tsx";
import { useNavigate } from "react-router-dom";
import { API_PARENT } from "../../../apiCaller/perent.Callerl.js";

interface Props {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  // data: ParentType | undefined;
  // dataFonction: fonctionType[];
  // dataGrade: gradeType[];
  // dataDomaine: domaineType[];
  dispatchReload: () => void;
}
const NewParent = (props: Props) => {
  const navigate = useNavigate();
  const [parentData, setparentData] = useState({
    nom: "",
    postnom: "",
    prenom: "",
    sexe: "M",
    ville: "",
    commune: "",
    quartier: "",
    avenue: "",
    telephone: "",
  });

  const [state, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });

  const handleChange = (e) => {
    setparentData({ ...parentData, [e.target.name]: e.target.value });
  };

  const handleCreate = async () => {
    if (
      !parentData.nom?.toString().length ||
      !parentData.postnom?.toString().length ||
      !parentData.prenom?.toString().length ||
      !parentData.ville?.toString().length ||
      !parentData.commune?.toString().length ||
      !parentData.quartier?.toString().length ||
      !parentData.telephone?.toString().length ||
      !parentData.avenue?.toString().length
    ) {
      return setState({
        ...state,
        errorMessage: "Veuiller complétez tous les champs",
      });
    }

    setState({ isLoading: true, errorMessage: null, successMessage: null });
    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      let data = {
        nom: parentData.nom,
        postnom: parentData.postnom,
        prenom: parentData.prenom,
        sexe: parentData.sexe,
        ville: parentData.ville,
        commune: parentData.commune,
        quartier: parentData.quartier,
        avenue: parentData.avenue,
        telephone: parentData.telephone,
      };
      const response = await API_PARENT.PARENT.create(data, token);

      // console.log(response);
      if (response.data.status === 200 || response.data.status === 201) {
        toast.success("Enregistrement effectué avec succès", {
          duration: 3000,
        });
        props.setOpen(false);
        props.dispatchReload();
      } else {
        toast.error("Une erreur s'est produite, réesayez plus tard", {
          style: {
            backgroundColor: "#630f0f", // Custom background color
            color: "white", // Text color
            fontSize: "12px", // Font size
            zIndex: 9999,
          },
        });
      }
    } catch (error) {
      // console.log(error);
      catchErrorApiCall(error);
    } finally {
      setState({ ...state, isLoading: false });
    }
  };

  //phone number state
  // const [phoneNumber, setPhoneNumber] = useState("");

  // const [selectedCountry, setSelectedCountry] = useState<string>("CD");
  return (
    <div className="UpdatePersonnel">
      <div className="dialog_update">
        <div className="headerUpdate">
          <div className="titleUpdate">
            <div className="left_">
              <Person2Sharp className="ico" />
              <span>Nouveau Parent</span>
            </div>
            <IconButton>
              <Close className="ico" onClick={() => props.setOpen(false)} />
            </IconButton>
          </div>
        </div>

        <div className="body_update">
          {state.errorMessage && <ErrorBar title={state.errorMessage} />}

          <div className="item">
            <label>Nom *</label>
            <input
              placeholder="Nom..."
              type="text"
              name="nom"
              value={parentData.nom?.toUpperCase()}
              onChange={handleChange}
            />
          </div>
          <div className="item">
            <label>Post-nom *</label>
            <input
              placeholder="Post-nom..."
              type="text"
              name="postnom"
              value={parentData.postnom?.toUpperCase()}
              onChange={handleChange}
            />
          </div>
          <div className="item">
            <label>Prénom *</label>
            <input
              placeholder="Prénom..."
              type="text"
              name="prenom"
              value={parentData.prenom?.toUpperCase()}
              onChange={handleChange}
            />
          </div>

          <div className="item">
            <label>Genre</label>
            <select
              onChange={handleChange}
              name="sexe"
              value={parentData.sexe?.toUpperCase()}
            >
              <option value="M">Masculin</option>
              <option value="F">Feminin</option>
            </select>
          </div>
          <div className="item">
            <label>Téléphone*</label>
            <input
              placeholder="Téléphone..."
              type="text"
              name="telephone"
              value={parentData.telephone}
              onChange={handleChange}
            />
          </div>

          {/* <div className="item country">
            <label>Pays</label>
            <ReactFlagsSelect
              selected={selectedCountry}
              onSelect={(code) => setSelectedCountry(code)}
              optionsSize={13}
              selectedSize={13}
              searchPlaceholder="Chercher pays"
              placeholder="Choix du pays"
              searchable
              className="menu-flags"
              selectButtonClassName="menu-flags-button"
            />
          </div> */}

          <div className="item">
            <label>Ville *</label>
            <input
              placeholder="Ville..."
              type="text"
              name="ville"
              value={parentData.ville?.toUpperCase()}
              onChange={handleChange}
            />
          </div>

          <div className="item">
            <label>Commune *</label>
            <input
              placeholder="Commune..."
              type="text"
              name="commune"
              value={parentData.commune?.toUpperCase()}
              onChange={handleChange}
            />
          </div>

          <div className="item">
            <label>Quartier *</label>
            <input
              placeholder="Quartier..."
              type="text"
              name="quartier"
              value={parentData.quartier?.toUpperCase()}
              onChange={handleChange}
            />
          </div>
          <div className="item">
            <label>Avenue *</label>
            <input
              placeholder="Avenue..."
              type="text"
              name="avenue"
              value={parentData.avenue?.toUpperCase()}
              onChange={handleChange}
            />
          </div>

          {/* <div className="item phone">
          <label>Téléphone *</label>
          <PhoneInput
            country={"cd"}
            value={phoneNumber}
            onChange={handleChangePhone}
          />
          {!validdNumber && (
            <span style={{ color: "red", fontSize: "12px" }}>
              Entrer un numéro valide
            </span>
          )}
        </div> */}
        </div>
        <div className="btn">
          <button onClick={() => props.setOpen(false)}>Annuler</button>
          {state.isLoading ? (
            <button>
              <LoaderIcon />
            </button>
          ) : (
            <button onClick={handleCreate}>Enregister</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewParent;
